module.exports = __webpack_public_path__ + "img/small-arrow.14fae8c8.svg";